<template>
  <div class="pagination-row">
    <div class="sort">
      <p>
        <span>{{ translations.sort }}</span>
      </p>
      <v-select
        name="sort_page"
        id="sort_page"
        :clearable="false"
        :options="sorts"
        :searchable="false"
        :filterable="false"
        :value="$store.state.view.sort"
        @input="setSelectedSort"
      ></v-select>
    </div>

    <div class="found-posts">
      <p v-if="this.getShowedProductsCount !== 0">
        {{ this.getShowedProductsCount }} / 
        {{ this.$store.state.productsCount }}
      </p>
    </div>

    <div class="perpage">
      <p>
        <span>{{ translations.perPage }}</span>
      </p>

      <v-select
        name="per_page"
        id="per_page"
        :clearable="false"
        :searchable="false"
        :filterable="false"
        :options="$store.state.view.perPageOptions"
        :value="$store.state.view.perPage"
        @input="setSelectedPerPage"
      >
      </v-select>
    </div>

    <div class="select-page">
      <button
        class="select-page__prev"
        v-on:click="prevPage"
        v-bind:class="{ disabled: this.$store.state.view.page == 1 }"
      >
        <span>‹</span>
      </button>
      <p>{{ $store.state.view.page }} / {{ this.getPageCount }}</p>
      <button
        class="select-page__next"
        v-on:click="nextPage"
        v-bind:class="{ disabled: this.$store.state.view.page == this.getPageCount }"
      >
        <span>›</span>
      </button>
    </div>

    <v-pagination
      v-model="$store.state.view.page"
      v-if="getPageCount > 0"
      :page-count="getPageCount"
      :classes="pagination.classes"
      :labels="pagination.anchorTexts"
      @input="setPage"
    ></v-pagination>

    <div class="select-view">
      <div class="select-view__grid">
        <button v-bind:class="[this.$store.state.view.type == 'kaali' ? 'selected' : '']" v-on:click="setView('kaali')">
          <i>
            <svg
              enable-background="new 0 0 15.9 16"
              version="1.1"
              viewBox="0 0 15.9 16"
              xml:space="preserve"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <title>background</title>
                <rect x="-1" y="-1" width="802" height="602" fill="none" />
              </g>
              <g>
                <title>Layer 1</title>
                <path
                  d="M0,0h6v6H0V0z M9.9,0h6v6h-6V0z M0,10h6v6H0V10z M9.9,10h6v6h-6V10z"
                  fill="#333"
                />
              </g>
            </svg>
          </i>
        </button>
      </div>
      <div class="select-view__table">
        <button v-bind:class="[this.$store.state.view.type == 'wells' ? 'selected' : '']" v-on:click="setView('wells')">
          <i>
            <svg
              enable-background="new 0 0 16 16"
              version="1.1"
              viewBox="0 0 16 16"
              xml:space="preserve"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <title>background</title>
                <rect x="-1" y="-1" width="802" height="602" fill="none" />
              </g>
              <g>
                <title>Layer 1</title>
                <path d="m0 0h16v4h-16v-4zm0 6h16v4h-16v-4zm0 6h16v4h-16v-4z" fill="#333" />
              </g>
            </svg>
          </i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import vPagination from "vue-plain-pagination";

export default {
  components: { vPagination },
  name: "PaginationWells",
  data() {
    return {
      translations: {
        sort: ws_vue_store.translations.sort,
        perPage: ws_vue_store.translations.per_page,
        postsFound: ws_vue_store.translations.posts_found
      },
      sorts: ws_vue_store.catalog_orderby_options,
      pagination: {
        currentPage: this.$store.state.view.page,
        classes: {
          ul: "pagination",
          li: "pagination-item",
          liActive: "pagination-item--active",
          liDisable: "pagination-item--disable",
          button: "pagination-link",
          buttonActive: "pagination-link--active",
          buttonDisable: "pagination-link--disable"
        },
        anchorTexts: {
          first: "&laquo;",
          prev: "&lsaquo;",
          next: "&rsaquo;",
          last: "&raquo;"
        },
        anchorTextsAlternative: {
          first: "First",
          prev: "Previous",
          next: "Next",
          last: "Last"
        }
      }
    };
  },
  mounted() {},
  watch: {
    "pagination.currentPage": function setNewPage(val) {
      if (this.$store.state.view.page !== val) {
        this.$store.commit("changeCurrentPage", val);
      }
    }
  },
  computed: {
    getPageCount() {
      return Math.ceil(this.$store.state.productsCount / this.$store.state.view.perPage);
    },
    getShowedProductsCount() {
      let minPerPage = (this.$store.state.view.page - 1) * this.$store.state.view.perPage + 1;
      if (this.$store.state.productsCount < this.$store.state.view.perPage) {
        return this.$store.state.productsCount;
      }
      if (this.$store.state.view.page == this.getPageCount) {
        let lessPerPage =
          this.$store.state.view.page * this.$store.state.view.perPage -
          this.$store.state.productsCount;
        let maxPerPage = this.$store.state.view.page * this.$store.state.view.perPage - lessPerPage;
        return minPerPage + "-" + maxPerPage;
      }
      let maxPerPage = this.$store.state.view.page * this.$store.state.view.perPage;
      return minPerPage + "-" + maxPerPage;
    }
  },
  methods: {
    setView(value){
      this.$store.commit("changeViewType", value);
    },
    setSelectedPerPage(value) {
      this.$store.commit("changePerPage", value);
      this.$store.commit("setFirstPage");
      this.$store.dispatch("getProducts");
    },
    setSelectedSort(value) {
      this.$store.commit("setSort", value);
      this.$store.commit("setFirstPage");
      this.$store.dispatch("getProducts");
    },
    setPage() {
      this.$store.commit("changeCurrentPage", this.$store.state.view.page);
      this.$store.dispatch("getProducts");
      this.scrollToProductsStart();
    },
    nextPage() {
      if (this.$store.state.view.page < this.getPageCount) {
        this.$store.commit("changeCurrentPage", (this.$store.state.view.page += 1));
        this.$store.dispatch("getProducts");
        this.scrollToProductsStart();
      }
    },
    prevPage() {
      if (this.$store.state.view.page > 1) {
        this.$store.commit("changeCurrentPage", (this.$store.state.view.page -= 1));
        this.$store.dispatch("getProducts");
        this.scrollToProductsStart();
      }
    },
    scrollToProductsStart(){
       window.scrollTo(0, document.querySelector('.products-layout').getBoundingClientRect().top + window.scrollY-175);
    },
  }
};
</script>

<style lang="scss">
.pagination-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4rem 0 2rem;

  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .vs--single.vs--open .vs__selected {
      position: relative;
    }

    .vs5__listbox {
      width: 100%;
    }

    .vs {
      &--searchable {
        padding: 0 1rem;
      }

      &--single {
        display: flex;
        flex-direction: column;
        align-items: center;

        ul {
          left: inherit;
          min-width: auto;
          width: auto;
        }
      }

      &__dropdown-toggle {
        border-radius: 2rem;
      }

      &__actions {
        svg {
          transform: scale(0.6);
        }
      }
    }
  }

  .sort,
  .perpage {
    p {
      margin-right: 1rem;
    }
  }

  .select-page {
    button {
      &.disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }
    }
  }

  .pagination {
    display: flex;

    &-item {
      padding: 0 1rem;
      align-self: center;
    }
  }

  .select-view {
    button {
      opacity: 0.9;

      &:not(.selected) {
        opacity: 0.3;
      }

      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>
